export default __webpack_public_path__ + "static/media/60.569fe8a8.gif";